<app-sidebar [fullPageView]="true"></app-sidebar>
